import actionTypes from "constants/modal";
import { Action, ActionFunctionAny, createActions } from "redux-actions";

const { OPEN_MODAL, UPDATE_MODAL, CLOSE_MODAL, ADD_MODAL, CLOSE_ALL_MODAL } = actionTypes;

const actions = createActions(OPEN_MODAL, UPDATE_MODAL, CLOSE_MODAL, ADD_MODAL, CLOSE_ALL_MODAL);

const add = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.addModal(params));

const open = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.openModal(params));

const update = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.updateModal(params));

const close = () => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.closeModal());

const closeAll = () => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.closeAllModal());

export default { ...actions, open, update, close, add, closeAll };
